import { useContext, useEffect } from 'react'
import { TextAreaField } from '@nv/basic-components'
import { ModalContext } from '@nv/contexts'
import { useFormik } from 'formik'
import { useTranslation } from 'react-i18next'
import * as Yup from 'yup'

export const Note = ({ confirm, initialNote = '' }: any) => {
  const { t } = useTranslation()
  const { setHeaderLabel, setBtns, onClose } = useContext(ModalContext)

  const formik = useFormik({
    initialValues: { description: initialNote },
    validationSchema: Yup.object({
      description: Yup.string().required(t('validation.required')),
    }),
    onSubmit: (values) => {
      confirm(values.description)
      onClose()
    },
  })

  useEffect(() => {
    setHeaderLabel(t('admin.electorsList.notes.addEditNotes'))
    setBtns([
      { text: t('buttons.cancel'), onClick: onClose, variant: 'secondary' },
      { text: t('buttons.save'), onClick: formik.submitForm },
    ])
  }, [])

  return (
    <>
      <TextAreaField
        formik={formik}
        field='description'
        label={initialNote ? t('admin.electorsList.notes.editNote') : t('admin.electorsList.notes.addNote')}
        // placeholder={t('notes.placeholder')}
        style={{ container: { minHeight: '300px' } }}
      />
    </>
  )
}
